// PaymentMethodModal/constants.ts

import {
  BankOption,
  CountryOption,
} from "@/pages/Wallet/components/paymentMethodModal/type";

export const INDIAN_BANKS: BankOption[] = [
  { id: "HDFC0000001", title: "HDFC Bank", country: "IN" },
  { id: "ICIC0000001", title: "ICICI Bank", country: "IN" },
  { id: "SBIN0000001", title: "State Bank of India", country: "IN" },
  { id: "UTIB0000001", title: "Axis Bank", country: "IN" },
  { id: "KKBK0000001", title: "Kotak Mahindra Bank", country: "IN" },
  { id: "CNRB0000001", title: "Canara Bank", country: "IN" },
  { id: "PUNB0000001", title: "Punjab National Bank", country: "IN" },
  { id: "BARB0000001", title: "Bank of Baroda", country: "IN" },
  { id: "IOBA0000001", title: "Indian Overseas Bank", country: "IN" },
  { id: "UBIN0000001", title: "Union Bank of India", country: "IN" },
  { id: "YESB0000001", title: "Yes Bank", country: "IN" },
  { id: "IDIB0000001", title: "Indian Bank", country: "IN" },
  { id: "CBIN0000001", title: "Central Bank of India", country: "IN" },
  { id: "MAHB0000001", title: "Bank of Maharashtra", country: "IN" },
  { id: "ALLA0000001", title: "Allahabad Bank", country: "IN" },
];

export const US_BANKS: BankOption[] = [
  { id: "CHASUS33", title: "JPMorgan Chase Bank", country: "US" },
  { id: "BOFAUS3N", title: "Bank of America", country: "US" },
  { id: "CITIUS33", title: "Citibank", country: "US" },
  { id: "WFBIUS6S", title: "Wells Fargo Bank", country: "US" },
  { id: "GOLDUS33", title: "Goldman Sachs Bank", country: "US" },
  { id: "MSTNUS33", title: "Morgan Stanley Bank", country: "US" },
  { id: "USBKUS44", title: "U.S. Bank", country: "US" },
  { id: "PNCCUS33", title: "PNC Bank", country: "US" },
  { id: "TDOMCATTTOR", title: "TD Bank", country: "US" },
  { id: "CAPOUS44", title: "Capital One Bank", country: "US" },
];

export const UK_BANKS: BankOption[] = [
  { id: "BARCGB22", title: "Barclays Bank", country: "UK" },
  { id: "HBUKGB4B", title: "HSBC Bank", country: "UK" },
  { id: "LOYDGB21", title: "Lloyds Bank", country: "UK" },
  { id: "NWBKGB2L", title: "NatWest Bank", country: "UK" },
  { id: "RBOSGGSX", title: "Royal Bank of Scotland", country: "UK" },
  { id: "SANTGB21", title: "Santander UK", country: "UK" },
  { id: "TSBUS44", title: "TSB Bank", country: "UK" },
  { id: "COBADEFF", title: "Commerzbank", country: "UK" },
];

export const ALL_BANKS = [...INDIAN_BANKS, ...US_BANKS, ...UK_BANKS];
